import { decodeBase64Url } from '@zealot/shared';
import logger from '@/utils/logger';
import type { JwtPayload } from './types';

// gloss
export const decodeJwt = (token: string): JwtPayload => {
  const segment = token.split('.')[1] ?? '';
  return JSON.parse(decodeBase64Url(segment));
};

// gloss
export const getTokenExpiryMs = (token: string): number | null => {
  try {
    const { exp } = decodeJwt(token);
    if (typeof exp !== 'number' || !Number.isFinite(exp)) return null;
    return exp * 1000;
  } catch (error) {
    logger.warn('Failed to decode JWT', { context: 'getTokenExpiryMs' });
    return null;
  }
};

// gloss
export const isTokenExpired = (token: string): boolean => {
  const expiresAt = getTokenExpiryMs(token);
  return expiresAt === null || Date.now() >= expiresAt;
};

// gloss
export const getTimeUntilExpiry = (token: string): number => {
  const expiresAt = getTokenExpiryMs(token);
  if (expiresAt === null) return 0;
  return Math.max(0, expiresAt - Date.now());
};

// gloss
export const shouldRefresh = (token: string, thresholdMs: number): boolean => getTimeUntilExpiry(token) <= thresholdMs;

// gloss
export const isUnauthenticatedToken = (token?: string | null): boolean => {
  if (!token) return false;
  try {
    return decodeJwt(token).role === 'unauthenticated';
  } catch (error) {
    logger.warn('Failed to decode JWT', { context: 'isUnauthenticatedToken' });
    return false;
  }
};
